enum KeyboardKey {
    Enter = 'Enter',
    Esc = 'Escape'
}

interface KeyboardEvent {
    preventDefault: () => void
    key: KeyboardKey | string
}

export function keyBoardPressActions(
    event: KeyboardEvent,
    cancel?: () => void,
    confirm?: () => void,
    cancelDisabled?: boolean,
    confirmDisabled?: boolean,
    trackKeyboardActions?: boolean,
    idExcludedFromKeyboardCancelConfirm?: string[]
): void {
    const elementFocused = idExcludedFromKeyboardCancelConfirm
        ? !!idExcludedFromKeyboardCancelConfirm.find(id => document.querySelectorAll(`[id^="${id}"]`).length !== 0)
        : false
    if (trackKeyboardActions && !elementFocused) {
        if (event.key === KeyboardKey.Enter) {
            if (!confirmDisabled) {
                event.preventDefault()
                if (confirm) confirm()
            }
        }
        if (event.key === KeyboardKey.Esc) {
            if (!cancelDisabled) {
                event.preventDefault()
                if (cancel) cancel()
            }
        }
    }
}
